import { ITaxRate, ITaxRatesState } from './types';
import { createSelector } from 'reselect';

export const initialSelectors = {
  selectIndexedTaxRates: () => ({}),
};

export const selectLoadedState = (state: ITaxRatesState) => state.loaded;
export const selectTaxRates = (state: ITaxRatesState) => state.taxRates;
export const selectTaxRate = (state: ITaxRatesState) => state.taxRate;
export const selectSyncError = (state: ITaxRatesState) => state.error;
export const selectSyncState = (state: ITaxRatesState) => state.syncing;
export const selectTaxRateSyncState = (state: ITaxRatesState) => state.taxRateSyncing;
export const selectTaxRateLoadedState = (state: ITaxRatesState) => state.taxRateLoaded;
export const selectTaxRateSavedState = (state: ITaxRatesState) => state.taxRateSaved;
export const selectTaxRatesTypesLoadedState = (state: ITaxRatesState) => state.loadedTaxRatesTypes;
export const selectTaxRatesTypes = (state: ITaxRatesState) => state.taxRatesTypes;
export const selectTaxRatesTypesSyncError = (state: ITaxRatesState) => state.errorTaxRatesTypes;
export const selectTaxRatesTypesSyncState = (state: ITaxRatesState) => state.syncingTaxRatesTypes;

export const selectIndexedTaxRates = createSelector(selectTaxRates, (taxRates) =>
  taxRates.reduce((indexed: { [x: string]: any }, taxRate: ITaxRate) => {
    if (taxRate.rateId) {
      indexed[taxRate.rateId] = taxRate;
    }
    return indexed;
  }, {})
);
